
import { Link } from 'react-router-dom';

const ProductCategories = () => {
  const productCategories = [
    {
      title: 'ManageEngine Suite',
      description: 'Comprehensive IT management solutions for enterprises',
      image: 'https://public.readdy.ai/ai/img_res/30db63dbd58ad68e94f0c9ff99a6438b.jpg',
      products: [
        'ServiceDesk Plus',
        'Support Center Plus',
        'Analytics Plus',
        'Endpoint Central',
        'Applications Manager',
        'Network Configuration Manager',
        'NetFlow Analyzer',
        'Log360',
        'PAM360',
        'Password Manager Pro',
        'ADManager Plus',
        'M365 Manager Plus',
        'ADSelfService Plus',
        'Exchange Reporter Plus'
      ],
      link: '/manageengine'
    },
    {
      title: 'AutomMate Platform',
      description: 'Business Process Automation and RPA solutions',
      image: 'https://readdy.ai/api/search-image?query=Business%20process%20automation%20workflow%20diagram%2C%20RPA%20robotic%20process%20automation%20interface%2C%20automated%20workflow%20designer%20with%20modern%20UI%2C%20enterprise%20automation%20platform%2C%20digital%20transformation%20tools&width=600&height=400&seq=automate-platform&orientation=landscape',
      products: [
        'Business Process Automation (BPA)',
        'Robotic Process Automation (RPA)',
        'Workflow Orchestration',
        'Process Designer',
        'Task Automation',
        'Integration Hub'
      ],
      link: '/autommate'
    },
    {
      title: 'Zoho One Ecosystem',
      description: 'Integrated business applications suite',
      image: 'https://readdy.ai/api/search-image?query=Zoho%20One%20business%20applications%20dashboard%2C%20integrated%20CRM%20and%20business%20suite%20interface%2C%20modern%20cloud-based%20business%20platform%2C%20unified%20business%20management%20system%20with%20clean%20design&width=600&height=400&seq=zoho-ecosystem&orientation=landscape',
      products: [
        'CRM & Sales Management',
        'HR & People Operations',
        'Finance & Accounting',
        'Project Management',
        'Marketing Automation',
        'Business Intelligence'
      ],
      link: '/zohoone'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-16">
          {productCategories.map((category, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <img 
                  src={category.image}
                  alt={category.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">{category.title}</h2>
                <p className="text-lg text-gray-600 mb-6">{category.description}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                  {category.products.map((product, idx) => (
                    <div key={idx} className="flex items-center">
                      <i className="ri-check-line text-teal-500 mr-3"></i>
                      <span className="text-gray-700">{product}</span>
                    </div>
                  ))}
                </div>
                <Link to={category.link}>
                  <button className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                    Learn More
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
